/**
 * Ashore API
 * All Endpoints to control your ashore account
 *
 * The version of the OpenAPI document: V1
 * Contact: info@ashoreapp.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import WorkflowStageApproverStatus from './WorkflowStageApproverStatus';

/**
 * The ReviewerAuditRecord model module.
 * @module model/ReviewerAuditRecord
 * @version V1
 */
class ReviewerAuditRecord {
    /**
     * Constructs a new <code>ReviewerAuditRecord</code>.
     * @alias module:model/ReviewerAuditRecord
     */
    constructor() { 
        
        ReviewerAuditRecord.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>ReviewerAuditRecord</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/ReviewerAuditRecord} obj Optional instance to populate.
     * @return {module:model/ReviewerAuditRecord} The populated <code>ReviewerAuditRecord</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new ReviewerAuditRecord();

            if (data.hasOwnProperty('id')) {
                obj['id'] = ApiClient.convertToType(data['id'], 'Number');
            }
            if (data.hasOwnProperty('approverId')) {
                obj['approverId'] = ApiClient.convertToType(data['approverId'], 'Number');
            }
            if (data.hasOwnProperty('proofId')) {
                obj['proofId'] = ApiClient.convertToType(data['proofId'], 'Number');
            }
            if (data.hasOwnProperty('proofVersionId')) {
                obj['proofVersionId'] = ApiClient.convertToType(data['proofVersionId'], 'Number');
            }
            if (data.hasOwnProperty('workflowStageId')) {
                obj['workflowStageId'] = ApiClient.convertToType(data['workflowStageId'], 'Number');
            }
            if (data.hasOwnProperty('accountId')) {
                obj['accountId'] = ApiClient.convertToType(data['accountId'], 'Number');
            }
            if (data.hasOwnProperty('ipAddress')) {
                obj['ipAddress'] = ApiClient.convertToType(data['ipAddress'], 'String');
            }
            if (data.hasOwnProperty('proofActionTaken')) {
                obj['proofActionTaken'] = WorkflowStageApproverStatus.constructFromObject(data['proofActionTaken']);
            }
            if (data.hasOwnProperty('actionTakenAt')) {
                obj['actionTakenAt'] = ApiClient.convertToType(data['actionTakenAt'], 'Date');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>ReviewerAuditRecord</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>ReviewerAuditRecord</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['ipAddress'] && !(typeof data['ipAddress'] === 'string' || data['ipAddress'] instanceof String)) {
            throw new Error("Expected the field `ipAddress` to be a primitive type in the JSON string but got " + data['ipAddress']);
        }

        return true;
    }


}



/**
 * @member {Number} id
 */
ReviewerAuditRecord.prototype['id'] = undefined;

/**
 * @member {Number} approverId
 */
ReviewerAuditRecord.prototype['approverId'] = undefined;

/**
 * @member {Number} proofId
 */
ReviewerAuditRecord.prototype['proofId'] = undefined;

/**
 * @member {Number} proofVersionId
 */
ReviewerAuditRecord.prototype['proofVersionId'] = undefined;

/**
 * @member {Number} workflowStageId
 */
ReviewerAuditRecord.prototype['workflowStageId'] = undefined;

/**
 * @member {Number} accountId
 */
ReviewerAuditRecord.prototype['accountId'] = undefined;

/**
 * @member {String} ipAddress
 */
ReviewerAuditRecord.prototype['ipAddress'] = undefined;

/**
 * @member {module:model/WorkflowStageApproverStatus} proofActionTaken
 */
ReviewerAuditRecord.prototype['proofActionTaken'] = undefined;

/**
 * @member {Date} actionTakenAt
 */
ReviewerAuditRecord.prototype['actionTakenAt'] = undefined;






export default ReviewerAuditRecord;

